import { Component } from '@angular/core';

@Component({
  selector: 'app-no-messages',
  templateUrl: './no-messages.component.html',
  standalone: false
})
export class NoMessagesComponent {
}
